<app-header #header title="Vehicles"></app-header>

<ion-content fullscreen="true" scrollEvents="true" [appHideHeader]="header" style="--background: var(--white, #FFF);">
  <app-header-content ></app-header-content>
  <app-pagecontent [path]="'vehicles'"></app-pagecontent>

  <ion-grid>
    <ion-row *ngIf="vehiclesSRV.vehicles &&   vehiclesSRV.vehicles.length>0">
      <ion-col size="12" class="ion-padding-horizontal">
        <h2 class="subheader-regular" style="text-align: center">
          {{ ('keys.data.users_menu.vehicles' | translate : {Default:'Vehicles'}) || "Vehicles"}}
        </h2>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="vehiclesSRV.loaded==false">
      <ion-col size-xs="11"
      offset-xs="0.5"
      size-sm="10" 
      offset-sm="1"
      size-md="6"   
      offset-md="0" 
      size-xl="4">
        <ion-card >
          <ion-card-header>
            <ion-card-title
              ><ion-skeleton-text animated style="width: 65%"></ion-skeleton-text
            ></ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <p>
              <ion-skeleton-text animated style="width: 88%"></ion-skeleton-text>
            </p>
            <ng-container>
              <p class="ion-padding-vertical">
                <ion-skeleton-text animated style="width: 70%"></ion-skeleton-text>
              </p>
            </ng-container>
            <p>
              <ion-skeleton-text animated style="width: 65%"></ion-skeleton-text
              ><br />
              <ion-skeleton-text animated style="width: 88%"></ion-skeleton-text
              ><br />
              <ion-skeleton-text animated style="width: 25%"></ion-skeleton-text>
            </p>
            <p class="ion-padding-top">
              <strong
                ><ion-skeleton-text animated style="width: 75%"></ion-skeleton-text
              ></strong>
            </p>
            
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
  
  
  <ion-grid *ngIf="vehiclesSRV.loaded==true && vehiclesSRV.vehicles &&   vehiclesSRV.vehicles.length>0" style="min-height: 75%;" >
    
      <ion-row *ngIf="vehiclesSRV.vehicles &&   vehiclesSRV.vehicles.length>0">
        <ion-col size="10" offset="1">
          <ion-grid style="padding: 0;margin: 0;">
            <ion-row>
              <ion-col
              style="padding: 0;"
              size-xs="11"
              offset-xs="0.5"
              size-sm="10" 
              offset-sm="1"
              size-md="6"   
              offset-md="0" 
              size-xl="4"
                *ngFor="let vehicle of vehiclesSRV.vehicles"
              >
               
              <ion-card  class="card-shadow-7"
              style="border-radius: 0.5em;height: 100%;"
             >
             <ion-card-content>
             <ion-grid  style="color: black;">
              <ion-row>
                <ion-col style="padding: 0.4em;">
                  <ion-label class="card-header-unique"> {{vehicle.ProvName}} | {{vehicle.PlateType.TypeName}}</ion-label>
                </ion-col>
                <ion-col size="2" style="text-align: right;" *ngIf="vehicle.electric_vehicle==1 || vehicle.electric_vehicle==true">
                  <ion-icon name="flash"></ion-icon>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="12">
                  <ion-grid>
                    
              
                          <ion-row *ngIf="vehicle.Plate" style="margin-bottom: 0.2em;">
                            <ion-col>
                              <ion-label class="paragraph-bold">{{vehicle.Plate}}</ion-label>
                            </ion-col>
                          </ion-row>
                          <ion-row *ngIf="vehicle.TypeName">
                            <ion-col>
                              <ion-label class="card-text-regular">{{vehicle.TypeName}}</ion-label>
                            </ion-col>
                          </ion-row>
                          <ion-row *ngIf="vehicle.Year">
                            <ion-col>
                              <ion-label class="card-text-regular">{{vehicle.Year}}</ion-label>
                            </ion-col>
                          </ion-row>
                          <ion-row *ngIf="vehicle.MakeName">
                            <ion-col>
                              <ion-label class="card-text-regular">{{vehicle.MakeName}}</ion-label>
                            </ion-col>
                          </ion-row>
                          <ion-row *ngIf="vehicle.ColourName">
                            <ion-col>
                              <ion-label class="card-text-regular">{{vehicle.ColourName}}</ion-label>
                            </ion-col>
                          </ion-row>
                  </ion-grid>
              
                  
                  </ion-col>
                  </ion-row>
                  <ion-row>
                        <ion-col size="12" >
                          <ion-item style="--background:transparent;" *ngIf="vehiclesSRV.loadingToggleChange.value == false" lines="none">
                            <ion-label class="card-text-bold" *ngIf="vehicle.Active == true">
                              {{ ('keys.data.common.active' | translate : {Default:'Active'}) || "Active" }}
                            </ion-label>
                            <ion-label class="card-text-bold" *ngIf="!vehicle.Active || vehicle.Active == false">
                              {{ ('keys.data.common.inactive' | translate : {Default:'Inactive'}) || "Inactive" }}
                            </ion-label>
                            <ion-toggle color="secondary" (ionChange)="vehiclesSRV.onToggleActive($event, vehicle.VehicleID)" [checked]="vehicle.Active"></ion-toggle>
                          </ion-item>
                          <ion-item style="--background:transparent" *ngIf="vehiclesSRV.loadingToggleChange.value == true" lines="none">
                            <ion-spinner style="display: block; margin: auto;" name="crescent"></ion-spinner>
                          </ion-item>
                        </ion-col>
                      </ion-row>
                
                      <ion-row>
                        <ion-col >
                          <ion-button expand="block"   (click)="vehiclesSRV.openEditVehicleModal(vehicle)">
                            {{ ('keys.data.common.edit' | translate : {Default:'Edit'}) || "Edit" }}
                          </ion-button>
                        </ion-col>
                        <ion-col   *ngIf="dataService.settings?.vehicles?.allow_user_delete">
                          <ion-button class="button-clear" fill="outline" color="danger" expand="block" (click)="vehiclesSRV.removeVehicle(vehicle)">
                            <ion-icon name="trash"></ion-icon> <ion-label>Remove </ion-label>
                          </ion-button>
                        </ion-col>
                  </ion-row>
                  </ion-grid>
                  </ion-card-content>
              </ion-card>
              
                      
                    
                  
               
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-col>
    
     
    </ion-row>
    <ion-row style="margin-top:1.5em;">
      <ion-col size="6" offset="3" style="text-align: center;">
        <ng-template [ngTemplateOutlet]="addVehicleButton" ></ng-template>
      </ion-col>
    </ion-row>
    
  </ion-grid>
  <ion-grid *ngIf="vehiclesSRV.loaded==true && vehiclesSRV.vehicles &&   vehiclesSRV.vehicles.length<1" style="min-height: 75%;" >
    <ion-row style="  
       align-items: center;">
       <ion-col>
        <h3 style="text-align: center">
          {{ ('keys.data.users_menu.vehicles' | translate : {Default:'Vehicles'}) || "Vehicles"}}
        </h3>
       </ion-col>
       </ion-row>
       <ion-row>
        <ion-col style="text-align: center;">
          <img src="assets/images/vehicles page.png">
        </ion-col>
       </ion-row>
       <ion-row>
        <ion-col style="text-align: center;">
          <h4>
            {{ ('keys.data.vehicles.no_user_vehicles' | translate : {Default:'User has no associated vehicles.'}) || "User has no associated vehicles."}}
          </h4>
        </ion-col>
       </ion-row>
       <ion-row style="margin-top:1.5em;">
        <ion-col size="6" offset="3" style="text-align: center;">
          <ng-template [ngTemplateOutlet]="addVehicleButton" ></ng-template>
        </ion-col>
      </ion-row>
      </ion-grid>
      
      <ion-footer class="ion-no-border"> 
        <app-footer></app-footer>
      </ion-footer>
</ion-content>
<ng-template #addVehicleButton>
  <ion-button
      color="primary"
      (click)="vehiclesSRV.openAddVehicleModal()"
    >
    <ion-icon name="add-circle"></ion-icon>
      {{ ('keys.data.vehicles.add_vehicle' | translate : {Default:'Add Vehicle'}) || "Add Vehicle"}}
    </ion-button>
</ng-template>
